import { useCallback, useEffect } from 'react';
import { useLocation } from 'react-router';

import { userModel } from '@/entities/user';

import api from '../api/api';
import { ENVIRONMENT } from '../config';
import { isDemoSession } from '../lib';

import { useAppSelector } from './store';

const HUBSPOT_SCRIPT_ID = 'hs-script-loader';
const HUBSPOT_SCRIPT_SRC = '//js-eu1.hs-scripts.com/148247336.js';

const loadHubspotScript = () => {
  if (document.getElementById(HUBSPOT_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = HUBSPOT_SCRIPT_ID;
  script.src = HUBSPOT_SCRIPT_SRC;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);
};

export const useHubspotChat = () => {
  const { search } = useLocation();
  const isTypewriter =
    new URLSearchParams(search).get('isTypewriter') === 'true';
  const user = useAppSelector(userModel.selectors.selectCurrentUser);
  const email = user.PersonalData?.Emails[0];
  const isLocalhost = ['localhost', '127.0.0.1'].includes(
    window.location.hostname,
  );
  const disableHubspot =
    isTypewriter ||
    ENVIRONMENT === 'development' ||
    isLocalhost ||
    localStorage.getItem('disableHubspot') === 'true';

  const onConversationsAPIReady = useCallback(async () => {
    const restartHubspot = () => {
      window.HubSpotConversations?.clear({ resetWidget: true });
      window.HubSpotConversations?.widget.load();
    };

    if (email && !isDemoSession()) {
      const { Token } = await api.hubspot.getChatIdentificationToken({});

      window.hsConversationsSettings = {
        loadImmediately: false,
        identificationEmail: email,
        identificationToken: Token,
      };

      if (Token && window.HubSpotConversations) {
        restartHubspot();
      } else {
        window.hsConversationsOnReady = [restartHubspot];
      }
    } else {
      window.hsConversationsSettings = {
        loadImmediately: true,
      };
    }
  }, [email]);

  useEffect(() => {
    if (disableHubspot) {
      return;
    }

    loadHubspotScript();

    onConversationsAPIReady();
  }, [disableHubspot, email, onConversationsAPIReady]);
};
